<template>
	<contentBox v-if="!loadError" v-bind:loading="!recLoaded">
		<contentTitle v-if="agent" label="USER ACCOUNT" close="home">
			<h2 class="text-white font-weight-light pb-2">{{agent.username}}</h2>
		</contentTitle>
		<contentBody v-if="agent">
			<!--contentActions>
				<button class="btn btn-outline-light btn-sm" v-on:click="logout">
					<i class="material-icons md-18" title="logout from scoutred">logout</i> 
					Logout
				</button>
			</contentActions-->
			<div class="p-3">
				<billing v-if="tab == 'billing'" :agent="agent" :planCurrent="planCurrent">
				</billing>
				<email v-else-if="tab == 'email'" :agent="agent">
				</email>
				<password v-else-if="tab == 'password'" :agent="agent">
				</password>
				<plan v-else-if="tab == 'plan'" :agent="agent" :planCurrent="planCurrent">
				</plan>
				<team v-else-if="tab == 'team'" :agent="agent" :planCurrent="planCurrent">
				</team>
				<overview v-else="" :agent="agent" :planCurrent="planCurrent">
				</overview>
			</div>
		</contentBody>
	</contentBox>
</template>
<script>

import billing from './agent-billing';
import contentBox from '../content';
import contentActions from '../content/content-actions';
import contentBody from '../content/content-body';
import contentTitle from '../content/content-title';
import email from './agent-email';
import overview from './agent-overview';
import password from './agent-password';
import plan from './agent-plan';
import team from './agent-team';

export default {
	name: 'agent',
	props:{
		tab: String,
	},
	components:{
		billing,
		contentBox,
		contentActions,
		contentBody,
		contentTitle,
		email,
		overview,
		password,
		plan,
		team,
	},
	created: function(){
		if (this.$route.params.tab) this.$data.tabActive = this.$route.params.tab;
		this.getRec();
	},
	data: function(){
		return {
			loadError:null,
			recLoaded:false,
			tabActive:'overview'
		}
	},
	computed: {
		agent:function(){
			return this.$store.state.agent.rec;
		},
		planCurrent:function(){
			return this.$store.state.plan.current;
		},
	},
	methods: {
		getRec: function(){
			this.loadError = null;
			this.$store.dispatch('AGENT_GET', {
			}).catch((error)=>{
				this.loadError = error;
			});			
		},
		logout: function(){
			this.$store.dispatch('AGENT_LOGOUT');
		},
		routeClose:function(){
			this.$router.push({
				name: 'home', 
				params:{}
			});
		},
		routeBack:function(){
			this.$router.go(-1);
		}
	},
	watch: {
		agent: function(newAgent){
			if (newAgent) this.recLoaded = true;
		},
		tab: function(newTab, oldTab){
			if (newTab === oldTab) return;
			this.$store.dispatch('SCROLL_CONTENT_TOP');
		},
	}
}

</script>
<style>
.title-nav{
	margin:0 0 1rem 0;
	padding:0;
}
.title-nav li{
	border-bottom:1px solid #EFEFEF;
	line-height:2.5rem;
	list-style-type:none;
	font-size:0.8rem;
	opacity:1;
	position:relative;
	padding-right:18px;
}
.title-nav li .back-btn i{
	position:relative;
	top:-2px;
	margin:0;
}
.title-nav i{
	position:relative;
	top:-1px;
	margin-right:4px;
}
.title-nav .back-btn{
	width:44px;
	height:44px;
	position:absolute;
	line-height:44px;
	left:-14px;
	top:-1px;
	text-align:center;
	cursor:pointer;
}
.title-nav .back-btn:hover{
	color:#0687D1;
}
.title-nav .title-label{
	padding-left:24px;
}
</style>


// WEBPACK FOOTER //
// src/components/agent/agent.vue